import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import GridWrapper from '../../../components/wrappers/GridWrapper';
import UserCard from '../../../components/userList/UserCard';
import GridWrapper100 from '../../../components/wrappers/GridWrapper100';

class UsersList extends Component {
  render() {
    const { userList } = this.props;

    return (
      <React.Fragment>
        <GridWrapper>
          <GridWrapper100 container spacing={16}>
            {userList.map(user => (
              <Grid item key={user.userId} xs={12} md={6} xl={4}>
                <UserCard {...user} />
              </Grid>
            ))}
          </GridWrapper100>
        </GridWrapper>
      </React.Fragment>
    );
  }
}

export default UsersList;



// WEBPACK FOOTER //
// ./src/routes/home/usersList/UsersList.js